// extracted by mini-css-extract-plugin
export default {"reports":"Reports_reports__zBDrh","navCards":"Reports_navCards__bhpRY"};